import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Button, Icon, Modal } from '@storable/canaveral-components';
import { resolveAssetUrl } from '../../../modules/assets';
import styles from './styles.scss';

const propTypes = {
  onDismiss: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

const defaultProps = {};

const WelcomeModal = ({
  onDismiss,
  show,
}) => (
  <Modal show={show} onDismiss={onDismiss} size="sm">
    <Modal.Header>
      <Modal.Title>Welcome to your new site admin!</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col xs={12}>
          <img src={resolveAssetUrl('/img/welcome-modal-image.png')} alt="welcome" className={styles.welcomeImage} />
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <span>
                Aren&apos;t sure where to begin? No worries, we have a guide to help you
                learn to use your new website admin.
              </span>
            </Col>
          </Row>
          <Row className={styles.span}>
            <Col xs={12}>
              <span>
                You can access the help site at any time from the&nbsp;
                <Icon
                  id="tool-tip"
                  label="help"
                  className={styles.helpIcon}
                />
                &nbsp;icon in the top right of the admin area.
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col xs={12}>
          <Button
            context="positive"
            className={styles.guideButton}
            onClick={onDismiss}
            target="_blank"
            componentClass="a"
            rel="noopener noreferrer"
            href="https://storedge.zendesk.com/hc/en-us/articles/360032180191-What-to-expect-from-your-new-website-an-FAQ"
          >
            Check out the guide
          </Button>
        </Col>
      </Row>
    </Modal.Body>
  </Modal>
);

WelcomeModal.propTypes = propTypes;
WelcomeModal.defaultProps = defaultProps;

export default WelcomeModal;
